import React from "react";
import HowitWorksSSS from "../HowitWorksSSS/HowitWorksSSS";

const HowitWorksPage = () => {
  return (
    <div className="contact-page">
      <HowitWorksSSS />
    </div>
  );
};

export default HowitWorksPage;
